import CardVoucher from '@/components/sections/builder/elements/body/cart-total/component/card-voucher';
import { Button } from '@/components/ui/button';
import { DrawerHeader, DrawerTitle, DrawerClose } from '@/components/ui/drawer';
import { calculateTotalDiscountPerPriority } from '@/lib/utils';
import { ThemeColorSchemeType, ThemePromotionType } from '@/stores/builder';
import { BasePromotion } from '@/types/http/promotion/common';
import { ArrowLeft, XIcon } from 'lucide-react';

type ActiveOffersListProps = {
  setDrawerView: React.Dispatch<
    React.SetStateAction<'cart' | 'voucher' | 'gift' | 'active_offers'>
  >;
  listPromotions?: BasePromotion[];
  grandTotal: number;
  colorSchemeCart?: ThemeColorSchemeType;
  promotionTheme?: ThemePromotionType;
  onRemovePromotion: (promo: BasePromotion) => void;
};

export default function ActiveOffersList({
  setDrawerView,
  listPromotions,
  grandTotal,
  onRemovePromotion,
  colorSchemeCart,
  promotionTheme,
}: ActiveOffersListProps) {
  const { updatedPromos } = calculateTotalDiscountPerPriority(listPromotions || [], grandTotal);

  return (
    <>
      <DrawerHeader className='flex items-center justify-between text-left'>
        <div className='flex items-center'>
          <Button
            variant={null}
            onClick={() => {
              setDrawerView('cart');
            }}
            size='icon'
          >
            <ArrowLeft className='theme_cart_drawer_color h-[18px] w-[18px]' />
          </Button>
          <DrawerTitle className='theme_cart_drawer_color'>
            {(listPromotions?.length ?? 0) > 0 ? listPromotions!.length : 'No'} Active Offers
          </DrawerTitle>
        </div>
        <DrawerClose onClick={() => setDrawerView('cart')}>
          <XIcon className='h-4 w-4' />
        </DrawerClose>
      </DrawerHeader>

      <div className='max-h-60 min-h-full overflow-y-auto p-2'>
        <div className='flex flex-col gap-1'>
          {updatedPromos?.map((promo) => (
            <CardVoucher
              key={promo.promotion_id}
              themeCart={colorSchemeCart}
              theme={promotionTheme}
              promo={promo}
              minSpending={promo.minimum_spending}
              grandTotal={grandTotal}
              onRemove={() => onRemovePromotion(promo)}
              isRemove
              isShowReward
              isCartDrawer
            />
          ))}
        </div>
      </div>
    </>
  );
}
